import { Routes } from '@angular/router';
import { authenticationGuard } from '@services';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(m => m.AUTH_ROUTES),
  },
  {
    path: '',
    loadChildren: () => import('./main/main.routes').then(m => m.MAIN_ROUTES),
    canActivate: [authenticationGuard],
    canActivateChild: [authenticationGuard],
  },
];
